<template>
  <Layout>
    <PageHead HeadType="Workflow" />
    <ProductOverview :summarizeText="SummarizeText" :videoData="videoData" />
    <ProductAbility :abilityData="AbilityData" abilityType="Workflow" />
    <ProductSuperiority :productSuperiorityData="ProductSuperiorityData" />
    <!-- 典型案例 -->
    <ClassicCases :classicCasesData="ClassicCasesData" />
  </Layout>
</template>

<script>
import Layout from '../../components/common/Layout'
import Icon from '../../components/icon/Icon'
import Separator from '../../components/elements/separator/Separator'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import ProductOverview from './components/ProductOverview.vue'
import ProductAbility from './components/ProductAbility.vue'
import ProductSuperiority from './components/ProductSuperiority/ProductSuperiority.vue'
import ClassicCases from '../IndustrySolution/components/ClassicCases.vue'
import {
  Workflow_icon01,
  Workflow_icon02,
  Workflow_icon03,
  Workflow_icon04,
  Workflow_icon05,
  Workflow_icon06,
  numImage01,
  numImage02,
  numImage03,
  numImage04,
  numImage05,
  zhongtongBackground,
  HITACHIBackground,
  YTOBackground,
  VERTIVIcon,
  ChianxinIcon,
  ASTRONERGYIcon,
  CenturySunshineIcon,
  CNFNIcon,
  InnoscienceIcon,
  JINMAOIcon,
  KAIFAIcon,
  ninebotIcon,
  WorkflowAbility01,
  WorkflowAbility02,
  WorkflowAbility03,
  WorkflowAbility04,
  WorkflowAbility05,
  WorkflowAbility06,
  WorkflowAbility07,
  WorkflowAbility08,
  WorkflowAbility09,
  WorkflowAbility10,
  WorkflowAbility11,
  WorkflowAbility12,
} from './Image.js'

export default {
  name: 'VyungWorkflow',
  components: {
    Icon, Layout, Separator, SectionTitle,
    ProductOverview, ProductAbility, ProductSuperiority, ClassicCases,
    PageHead: () => import('./components/PageHead'),
  },
  data () {
    return {
      //产品概述
      videoData: [{
        src: process.env.VUE_APP_VIDEO_URL + '/$web/video/workflow.mp4?' + process.env.VUE_APP_VIDEO_RAXWDL,
        // src:'https://vyunghome.blob.core.chinacloudapi.cn/$web/video/workflow.mp4?sp=racwdl&st=2023-05-23T06:12:11Z&se=2023-06-23T14:12:11Z&spr=https&sv=2022-11-02&sr=c&sig=ajt5HDJh%2BGE7TJ%2Bdo8uNSAqOUJzZWan37uhgbk%2B7bRI%3D',
        thumb: require(`@/assets/images/ProductService/VyungWorkflow/workflow_tumb.png`)
      }],
      SummarizeText: this.$t('product.VyungWorkflow.product_overview.text'),
      //业务蓝图
      //产品功能
      AbilityData: [
        {
          title: this.$t('product.VyungWorkflow.product_ability.title01'),
          text: [{
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext01'),
          }, {
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext02'),
          },],
          contentImage: WorkflowAbility01,
          numImage: numImage01,
        },
        {
          title: this.$t('product.VyungWorkflow.product_ability.title02'),
          contentImage: WorkflowAbility02,
          numImage: numImage02,
        },
        {
          title: this.$t('product.VyungWorkflow.product_ability.title03'),
          text: [{
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext03'),
          }, {
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext04'),
          },
          {
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext05'),
          },
          {
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext06'),
          }],
          contentImage: WorkflowAbility03,
          numImage: numImage03,
        },
        {
          title: this.$t('product.VyungWorkflow.product_ability.title04'),
          text: [{
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext07'),
          }, {
            subtext: this.$t('product.VyungWorkflow.product_ability.text.subtext08'),
          },],
          contentImage: WorkflowAbility04,
          numImage: numImage04,
        },
        {
          title: this.$t('product.VyungWorkflow.product_ability.title05'),
          contentImage: [
            WorkflowAbility05,
            WorkflowAbility06,
            WorkflowAbility07,
            WorkflowAbility08,
            WorkflowAbility09,
            WorkflowAbility10,
            WorkflowAbility11,
            WorkflowAbility12,
          ],
          numImage: numImage05,
        },
      ],

      //产品优势
      ProductSuperiorityData: [
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card01.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card01.text'),
          contentImage: Workflow_icon01,
        },
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card02.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card02.text'),
          contentImage: Workflow_icon02,
        },
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card03.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card03.text'),
          contentImage: Workflow_icon03,
        },
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card04.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card04.text'),
          contentImage: Workflow_icon04,
        },
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card05.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card05.text'),
          contentImage: Workflow_icon05,
        },
        {
          title: this.$t('product.VyungWorkflow.product_advangtages.card06.title'),
          text: this.$t('product.VyungWorkflow.product_advangtages.card06.text'),
          contentImage: Workflow_icon06,
        }
      ],

      //产品案例
      ClassicCasesData: [
        {
          // imageBackground: HITACHIBackground,
          brandIcon: VERTIVIcon,
        },
        {
          // imageBackground: zhongtongBackground,
          brandIcon: ASTRONERGYIcon,
        },
        {
          brandIcon: ChianxinIcon,
        }, {
          brandIcon: CenturySunshineIcon,
        }, {
          brandIcon: CNFNIcon,
        }, {
          brandIcon: InnoscienceIcon,
        }, {
          brandIcon: JINMAOIcon,
        }, {
          brandIcon: KAIFAIcon,
        }, {
          brandIcon: ninebotIcon,
        },
      ]
    }
  },
  methods: {
  
  }
}
</script>